import { fileToDataUri } from '../../../helpers/files';
import { getFileChecksum } from '../../../helpers/files/getFileChecksum';
import { UploadImage } from '../../../helpers/hooks/useImageUpload';
import { getImageDimensions } from '../../../helpers/images';

export const uploadFiles = async (files: File[], uploadFile: UploadImage): Promise<string[]> => {
  return Promise.all(
    files.map(async file => {
      const checksum = await getFileChecksum(file);
      const dataUrl = await fileToDataUri(file);
      const signedId = await uploadFile(file, {
        contentType: file.type,
        filename: file.name,
        byteSize: file.size,
        checksum,
        // upload Image hook can be used for files other than images but it still wants dimensions.
        // for files other than images we can set width and height to 1.
        ...(file.type.startsWith('image')
          ? await getImageDimensions(dataUrl)
          : { width: 1, height: 1 }),
      });
      return signedId;
    }),
  );
};
